import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { fetchAllProducts } from "../firebase/fireStoreServices";
import { Link } from "react-router-dom";

export default function AllProductsPage() {
  const [products, setProducts] = useState([]);

  // Fetching Product data from database through service layer i.e. firebase/fireStoreServices
  useEffect(() => {
    const loadProducts = async () => {
      const prodData = await fetchAllProducts();
      setProducts(prodData);
    };
    loadProducts();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ bgcolor: "white", mt: 3 }}>
      <Divider>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="secondary"
        >
          Our Products
        </Typography>
      </Divider>
      <Box sx={{ mt: 1, p: 3 }}>
        <Grid container spacing={2} justifyContent="center">
          {products.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
              <Card
                sx={{
                  height: 280, // 🔹 Set a fixed height for all cards
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 5,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 15,
                  },
                }}
              >
                <CardActionArea component={Link} to={`/product/${product.id}`}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={product.image}
                    alt={product.title}
                    loading="lazy"
                    sx={{ objectFit: "cover", borderRadius: 2 }}
                  />
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color="secondary"
                    >
                      {product.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {product.subtitle}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
